import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * LanguageSwitcher Component
 * Allows users to switch between available languages (English and Portuguese Brazil)
 * Language preference is saved to localStorage via i18next-browser-languagedetector
 */
export const LanguageSwitcher = ({ className = '' }) => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'pt-BR', name: 'Português (Brasil)', flag: '🇧🇷' },
  ];

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
  };

  return (
    <div className={`language-switcher flex gap-2 ${className}`}>
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => handleLanguageChange(lang.code)}
          className={`
            px-3 py-2 rounded-md text-sm font-medium transition-colors
            ${
              i18n.language === lang.code
                ? 'bg-primary-600 text-white'
                : 'bg-gray-200 text-gray-900 hover:bg-gray-300'
            }
          `}
          title={lang.name}
          aria-label={`Switch to ${lang.name}`}
          aria-current={i18n.language === lang.code ? 'true' : 'false'}
        >
          <span className="mr-1">{lang.flag}</span>
          {lang.code === 'en' ? 'EN' : 'PT-BR'}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
